export type Milleage = {
  value: string;
  label: string;
};

export const getMileages = (): Milleage[] => {
  const milesText = 'miles';
  const toText = 'to';
  const overText = 'Over';
  return [
    { value: '0-10,000', label: `0 ${toText} 10,000 ${milesText}` },
    { value: '10,000-20,000', label: `10,001 ${toText} 20,000 ${milesText}` },
    { value: '20,000-30,000', label: `20,001 ${toText} 30,000 ${milesText}` },
    { value: '30,000-40,000', label: `30,001 ${toText} 40,000 ${milesText}` },
    { value: '40,000-50,000', label: `40,001 ${toText} 50,000 ${milesText}` },
    { value: '50,000-60,000', label: `50,001 ${toText} 60,000 ${milesText}` },
    { value: '60,000-70,000', label: `60,001 ${toText} 70,000 ${milesText}` },
    { value: '70,000-80,000', label: `70,001 ${toText} 80,000 ${milesText}` },
    { value: '80,000-90,000', label: `80,001 ${toText} 90,000 ${milesText}` },
    { value: '90,000-100,000', label: `90,001 ${toText} 100,000 ${milesText}` },
    { value: '100,000-110,000', label: `100,001 ${toText} 110,000 ${milesText}` },
    { value: '110,000-120,000', label: `110,001 ${toText} 120,000 ${milesText}` },
    { value: '120,000-130,000', label: `120,001 ${toText} 130,000 ${milesText}` },
    { value: '130,000-140,000', label: `130,001 ${toText} 140,000 ${milesText}` },
    { value: '140,000-150,000', label: `140,001 ${toText} 150,000 ${milesText}` },
    { value: 'Over 150,000 miles', label: `${overText} 150,000 ${milesText}` },
  ];
};
